import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=5615f2ec&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=js&"
export * from "./photo.vue?vue&type=script&lang=js&"
import style0 from "./photo.vue?vue&type=style&index=0&id=5615f2ec&scoped=true&lang=css&"
import style1 from "./photo.vue?vue&type=style&index=1&id=5615f2ec&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5615f2ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5615f2ec')) {
      api.createRecord('5615f2ec', component.options)
    } else {
      api.reload('5615f2ec', component.options)
    }
    module.hot.accept("./photo.vue?vue&type=template&id=5615f2ec&scoped=true&", function () {
      api.rerender('5615f2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/photo.vue"
export default component.exports